<script setup lang="ts">
import {
  IAutomationAppResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IAutomationAppResponseInstance'
import {computed} from 'vue'

interface Props {
  app: IAutomationAppResponseInstance
  sizeRem?: number
}

const props = withDefaults(defineProps<Props>(), {
  sizeRem: 1.75,
})

function initial(name?: string): string {
  const s = (name || 'A').trim()
  return s.slice(0, 1).toUpperCase()
}

const letterFontRem = computed(() => {
  return Math.max(0.45, props.sizeRem * 0.42)
})
</script>

<template>
  <div
    class="automation-app-round-avatar"
    :style="{
      width: `${sizeRem}rem`,
      height: `${sizeRem}rem`,
      backgroundColor: app.iconColor || undefined,
    }"
  >
    <img
      v-if="app.completedIconFileVariants?.[0]?.url"
      :src="app.completedIconFileVariants[0].url"
      :alt="app.name || ''"
      class="automation-app-round-avatar__img"
    />
    <span
      v-else
      class="automation-app-round-avatar__letter"
      :style="{ fontSize: `${letterFontRem}rem` }"
    >{{initial(app.name)}}</span>
  </div>
</template>

<style scoped lang="scss">
@use '../../../styles/variables' as variables;

.automation-app-round-avatar {
  background-color: map-get(variables.$colors, container-high);
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.automation-app-round-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: map-get(variables.$spacing, space-0-5);
  border-radius: 50%;
}

.automation-app-round-avatar__letter {
  font-weight: 700;
  line-height: 1;
  color: map-get(variables.$colors, content-bright);
}
</style>
